<template>
	<main-container>
		<material-card icon="fas fa-sliders-h" :title="$t('options.table_title')">
			<ValidationObserver ref="OptionsObserver" v-slot="{ failed }">
				<v-row dense v-if="tenant_config.settings || user_config.settings">
					<template v-if="tenant_config.settings">
						<v-col cols="12" xs="12" sm="6">
							<v-select :disabled="config_loading" v-model="tenant_config.settings.AttachmentsViewStyle" :items="AttachmentsViewStyleOptions" item-text="label" item-value="value" :label="$t('options.AttachmentsViewStyle')" @change="updateTenantConfig('AttachmentsViewStyle', tenant_config.settings.AttachmentsViewStyle)"></v-select>
						</v-col>
					</template>
					<template v-if="user_config.settings">
						<v-col cols="12" xs="12" sm="6">
							<v-select :disabled="config_loading" v-bind:items="[10, 15, 50]" v-model="user_config.settings.DefaultRowsInTable" :label="$t('options.DefaultRowsInTable')" @change="updateUserConfig('DefaultRowsInTable', user_config.settings.DefaultRowsInTable)"></v-select>
						</v-col>
					</template>
				</v-row>
			</ValidationObserver>
		</material-card>
	</main-container>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		apierrors() {
			return this.$store.getters.getApiErrors;
		},
		user() {
			return this.$store.getters.getUser;
		},
		FiscalYearTypeOptions() {
			return [
				{ value: "SOLAR", label: "Anno Solare (Gennaio - Dicembre)" },
				{ value: "ASD", label: "Anno Associativo (Settembre - Agosto)" },
			];
		},
		HolidayMonthsOptions() {
			return [
				{ value: "1", label: "Gennaio" },
				{ value: "2", label: "Febbraio" },
				{ value: "3", label: "Marzo" },
				{ value: "4", label: "Aprile" },
				{ value: "5", label: "Maggio" },
				{ value: "6", label: "Giugno" },
				{ value: "7", label: "Luglio" },
				{ value: "8", label: "Agosto" },
				{ value: "9", label: "Settembre" },
				{ value: "10", label: "Ottobre" },
				{ value: "11", label: "Novembre" },
				{ value: "12", label: "Dicembre" },
			];
		},
		AttachmentsViewStyleOptions() {
			return [
				{ value: "table", label: "Tabella Riepilogo" },
				{ value: "preview", label: "Anteprima individuale" },
			];
		},
		tenant_config: {
			get: function () {
				return this.$store.getters.getTenantConfig;
			},
			set: function (value) {
				this.$store.commit("setTenantConfig", value);
			},
		},
		user_config: {
			get: function () {
				return this.$store.getters.getUserConfig;
			},
			set: function (value) {
				this.$store.dispatch("setUserConfig", value);
			},
		},
		config_loading() {
			return this.$store.getters.config_loading;
		},
	},
	methods: {
		updateTenantConfig(key, value) {
			if (key) {
				this.$refs.OptionsObserver.validate().then((isValid) => {
					if (isValid == true) {
						this.$store.dispatch("setTenantConfig", { key: key, value: value });
					}
				});
			}
		},
		updateUserConfig(key, value) {
			if (key) {
				this.$store.dispatch("setUserConfig", { key: key, value: value });
			}
		},
	},
	watch: {
		apierrors: {
			handler: function (val) {
				this.$functions.ApiErrorsWatcher(val, this.$refs.OptionsObserver);
			},
			deep: true,
		},
	},
};
</script>
